import { render, staticRenderFns } from "./DeliveryCustomer.vue?vue&type=template&id=91c29888&"
import script from "./DeliveryCustomer.vue?vue&type=script&lang=js&"
export * from "./DeliveryCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports